// extracted by mini-css-extract-plugin
export default {"placeholder":"MapPlaceholder_placeholder__R4zLd"};